import NewsCard from "../../components/Tips/NewsCard";

const tipsData = [
	{
		title: "Comprendre sa facture pour mieux agir",
		url: "https://symphonics.fr/comprendre-sa-facture-pour-mieux-agir/",
	},
	{
		title: "Agir sur votre consommation",
		url: "https://symphonics.fr/agir-sur-sa-consommation/",
	},
	{
		title: "Privilégier les ampoules basse consommation",
		url: "https://symphonics.fr/privilegier-les-ampoules-basse-consommation/",
	},
	{
		title: "Déporter sa consommation vers les heures creuses",
		url: "https://symphonics.fr/deporter-sa-consommation-hc-hp/",
	},
	{
		title: "Maîtriser le chauffage électrique, premier poste de consommation",
		url: "https://symphonics.fr/maitriser-le-chauffage-electrique-premier-poste-de-consommation/",
	},
	{
		title: "Adopter un usage raisonné des appareils numériques",
		url: "https://symphonics.fr/adopter-un-usage-raisonne-des-appareils-numeriques/",
	},
	{
		title: "Gérer intelligemment les appareils en veille",
		url: "https://symphonics.fr/gerer-intelligemment-les-appareils-en-veille/",
	},
	{
		title: "Rafraîchir son logement sans climatisation",
		url: "https://symphonics.fr/rafraichir-son-logement-sans-climatisation/",
	},
	{
		title: "Produire sa propre électricité grâce aux énergies renouvelables",
		url: "https://symphonics.fr/produire-sa-propre-electricite-grace-aux-energies-renouvelables/",
	},
	{
		title: "Faire des travaux de rénovation",
		url: "https://symphonics.fr/faire-des-travaux-de-renovation/",
	},
];

const Tips = () => {
	return (
		<div className="px-2 py-4 mb-20 mt-10">
			<div className="p-2 mb-4">
				<h1 className="text-xl font-bold text-gray-800">
					Nos conseils et astuces
				</h1>
			</div>
			<div className="px-2 space-y-4">
				{tipsData.map((tip) => (
					<NewsCard key={tip.title} title={tip.title} url={tip.url} />
				))}
			</div>
		</div>
	);
};

export default Tips;
